import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "./corporate.css";
import plan4 from '../Assests/images/Plan4_img.png'
import plan5 from '../Assests/images/Plan5_img.png'
import plan6 from '../Assests/images/Plan6_img.png'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const links = [
  {
    img: "./../assets/corporateAssert/Sec2(1)_img.png",
    text: "Expert Ayurveda Health Coaching",
  },
  {
    img: "./../assets/corporateAssert/Sec2(2)_img.png",
    text: "Personalized Health Recommendations",
  },
  {
    img: "./../assets/corporateAssert/Sec2(3)_img.png",
    text: "Smart Tracking for proactive decisions",
  },
  {
    img: plan4,
    text: "Seamless Access to Ayurvedic Remedies",
  },
  {
    img: plan5,
    text: "Digital Nadi (Pulse) Diagnosis",
  },
  {
    img: plan6,
    text: "Holistic Preventive Care Program",
  },
];

export default function DoctorProfiles() {
  
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const activeIndexRef = useRef(activeIndex);

  useEffect(() => {
    activeIndexRef.current = activeIndex;
  }, [activeIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % links.length);
    }, 800);
    return () => clearInterval(interval);
  }, []);

  const handleClick = (index) => {
    setActiveIndex(index);
    const sectionTop = sectionRef.current.offsetTop;
    const sectionHeight = sectionRef.current.offsetHeight;
    const targetProgress = index === 0 ? 0 : index === 1 ? 0.5 : 1;
    const targetScroll = sectionTop + sectionHeight * targetProgress;
    gsap.to(window, { scrollTo: targetScroll, duration: 0.5 });
  };

  return (
    <div className="doctor-container h-full" ref={sectionRef}>
      <div className="doctor-background h-full">
        <section className="doctor-content">

          <div className="doctor-image-section" ref={imageRef}>
            <div className="image-wrapper">
              <img
                src={links[activeIndex].img}
                className="doctor-main-image fade-in"
                alt="Doctor Main"
              />
            </div>
          </div>

          <div className="doctor-info-section h-full">
            <h1 className="doctor-title">What's included:</h1>
            <h3 className="doctor-sub">Our Comprehensive Wellness Plan – ₹500/month</h3>
    
            <div className="mt-10 h-full">
              {links.map((item, index) => (
                <div
                  key={index}
                  className={`doctor-card ${activeIndex === index ? "active" : ""
                    }`}
                  onClick={() => handleClick(index)}
                >
                  <div className="specialty-container">
                    <img
                      src="./../assets/corporateAssert/checkIcon.png"
                      className="checkIcon"
                      alt="check"
                    />
                    <span className="doctor-specialty">{item.text}</span>
                  </div>
                </div>
              ))}
            </div>

          </div>

        </section>
      </div>
    </div>
  );
}
